import ActionTypes from "./ActionTypes";
import Dispatcher from "./Dispatcher";

export default {
  getAll() {
    Dispatcher.dispatch({
      actionType: ActionTypes.MANUALS_FETCH,
    });
  },
  manualLoad(manualId, collectionId) {
   Dispatcher.dispatch({
     actionType: ActionTypes.MANUAL_SAVE_ACTIVITY_FETCH,
     collectionId,
     manualId
   });
  }
}
